import { Navigate, useRoutes } from "react-router-dom"

import { DetailSegmentSelectListener, SegmentSelectListener } from "@l2r-front/l2r-common"
import { MapAdapterBoundingBox, MapAdapterRoad } from "@l2r-front/l2r-networks"

import { SpeedingsSidebar } from "../../containers/SpeedingsSidebar"

export const SpeedingsMobileRoutes = () => {

    const speedingsRoutes = useRoutes([
        {
            path: "/*",
            element: <>
                <MapAdapterBoundingBox />
                <SpeedingsSidebar />
                <SegmentSelectListener />
            </>,
        },
        {
            path: "/:road",
            element: <>
                <DetailSegmentSelectListener />
                <MapAdapterRoad />
                <SpeedingsSidebar />
            </>,
        },
        {
            path: "/:road/*",
            element: <Navigate replace to={"."} />,
        },
    ])

    return speedingsRoutes
}